module.exports = __webpack_public_path__ + "img/main-gallery6.2771ede4.webp";